import { FC, useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { DropDownMultiFilterSelector } from '@frontend/analytics-shared';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const AppointmentTypeFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  const isDisabled = disabled || isLoading;

  const onChange = useCallback(
    (value: string[]) => {
      updateFilterValues({ appointmentTypes: value as CallIntelTypes.AppointmentTypeEnum[] });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ appointmentTypes: !!filterValues.appointmentTypes?.length });
  }, [filterValues.appointmentTypes, updateFilterModified]);

  return (
    <FilterTraySection
      label={t('Appointment Type')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <DropDownMultiFilterSelector
        label={t('Select Appointment Types')}
        onChange={onChange}
        options={getOptions('appointmentTypes', 'array')}
        trackingId={trackingIds.callIntel.appointmentTypesFilter}
        value={filterValues.appointmentTypes}
      />
    </FilterTraySection>
  );
};
